import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const mapStateToProps = state => ({
  user: state.auth.user,
  role: state.settings.role
});

export default selectedRole =>
  compose(
    connect(mapStateToProps),
    withRouter,
    lifecycle({
      componentDidMount() {
        const {
          role,
          history: { goBack }
        } = this.props;
        if (role !== selectedRole) {
          goBack();
        }
      }
    })
  );
